import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
let sdkPromise;
function loadGoogle() {
  if (window.google?.accounts?.id) return Promise.resolve(window.google.accounts.id);
  if (!sdkPromise) sdkPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client'; script.async = true;
    const timeout = setTimeout(() => { script.remove(); sdkPromise = null; reject(new Error('timeout')); }, 12000);
    script.onload = () => { clearTimeout(timeout); if (window.google?.accounts?.id) resolve(window.google.accounts.id); else { sdkPromise = null; reject(new Error('sdk')); } };
    script.onerror = () => { clearTimeout(timeout); script.remove(); sdkPromise = null; reject(new Error('sdk')); };
    document.head.appendChild(script);
  });
  return sdkPromise;
}
export default function GoogleLogin({ onSuccess }) {
  const container = useRef(null);
  const success = useRef(onSuccess); success.current = onSuccess;
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    const target = container.current;
    const api = process.env.REACT_APP_API_URL || '';
    async function setup() {
      try {
        const { data } = await axios.get(`${api}/api/auth/google/config`, { withCredentials: true });
        if (!active || !data.enabled) return;
        const google = await loadGoogle();
        if (!active) return;
        google.initialize({ client_id: data.clientId, nonce: data.nonce, callback: async ({ credential }) => {
          if (!active) return;
          setBusy(true); setError('');
          try {
            const response = await axios.post(`${api}/api/auth/google`, { credential, nonce: data.nonce }, { withCredentials: true });
            if (active) success.current(response.data);
          } catch (err) {
            if (active) { setError(err.response?.data?.message || 'Não foi possível entrar com Google. Tente novamente.'); container.current?.replaceChildren(); }
          } finally { if (active) setBusy(false); }
        } });
        google.renderButton(container.current, { type: 'standard', theme: 'outline', size: 'large', text: 'continue_with', locale: 'pt-BR', width: Math.max(200, Math.min(400, container.current.clientWidth || 300)) });
      } catch { if (active) setError('Google indisponível. Você pode usar seu e-mail e senha.'); }
    }
    setup();
    return () => { active = false; target?.replaceChildren(); };
  }, [attempt]);
  return <div style={{ marginBottom: 12 }} aria-busy={busy}>
    <div ref={container} />
    {busy && <p role="status">Entrando…</p>}
    {error && <><p role="alert" className="erro-texto">{error}</p><button type="button" onClick={() => { setError(''); setAttempt(v => v + 1); }}>Tentar Google novamente</button></>}
  </div>;
}
